import React from "react";
import Header from "./Header";

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
        <Header/>
        <div>
            <h1>Privacy Policy</h1>
            <p><strong>Last Updated:</strong> 12/1/2026</p>

            <h2>1. Introduction</h2>
            <p>
                Nkechukwu's Vision LTD (“NV”) respects your privacy and is committed to
                protecting your personal information.
            </p>

            <h2>2. Information We Collect</h2>
            <ul>
                <li>Personal information (name, email, address)</li>
                <li>Transaction and auction data</li>
                <li>Uploaded images and videos</li>
                <li>Device and usage analytics</li>
            </ul>

            <h2>3. How We Use Information</h2>
            <p>
                Information is used to operate the Platform, facilitate transactions,
                authenticate items, arrange secure delivery, and comply with legal
                requirements.
            </p>

            <h2>4. Media Content Usage</h2>
            <p>
                Images and videos displayed on the Platform may belong to independent
                artists and jewellers. NV does not claim ownership of third-party works.
            </p>

            <h2>5. Content Removal Requests</h2>
            <p>
                Artists or jewellers may request content removal by emailing
                <strong> nkechukwu@nv.luxury</strong> with proof of ownership and a
                clear reference to the content.
            </p>

            <h2>6. Data Security</h2>
            <p>
                Reasonable safeguards are implemented to protect personal data; however,
                no system is completely secure.
            </p>

            <h2>7. Your Rights</h2>
            <p>
                You may request access, correction, or deletion of your data where
                permitted by law.
            </p>

            <h2>8. Contact</h2>
            <p>Email: nkechukwu@nv.luxury</p>
        </div>
      
    </div>
  );
};

export default PrivacyPolicy;
